var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRuleQueueManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 2C1.425 2 0.75 2.675 0.75 3.5C0.75 4.325 1.425 5 2.25 5C3.075 5 3.75 4.3325 3.75 3.5C3.75 2.6675 3.0825 2 2.25 2ZM1.125 5.75C0.5025 5.75 0 6.2525 0 6.875V10.25H0.75V14H3.75V10.25H4.5V6.875C4.5 6.2525 3.9975 5.75 3.375 5.75H1.125Z",
    fill: "#CCCFD1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 2C7.175 2 6.5 2.675 6.5 3.5C6.5 4.325 7.175 5 8 5C8.825 5 9.5 4.3325 9.5 3.5C9.5 2.6675 8.8325 2 8 2ZM6.875 5.75C6.2525 5.75 5.75 6.2525 5.75 6.875V10.25H6.5V14H9.5V10.25H10.25V6.875C10.25 6.2525 9.7475 5.75 9.125 5.75H6.875Z",
    fill: "#CCCFD1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 2C12.925 2 12.25 2.675 12.25 3.5C12.25 4.325 12.925 5 13.75 5C14.575 5 15.25 4.3325 15.25 3.5C15.25 2.6675 14.5825 2 13.75 2ZM12.625 5.75C12.0025 5.75 11.5 6.2525 11.5 6.875V10.25H12.25V14H15.25V10.25H16V6.875C16 6.2525 15.4975 5.75 14.875 5.75H12.625Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRuleQueueManagement);
export default __webpack_public_path__ + "static/media/icon-rule-queue-management.5faa935845ece9306103696c591f828a.svg";
export { ForwardRef as ReactComponent };